import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';

import ErrorFallback from '@/components/ErrorFallback';
import { AppHeader } from '@/components/organisms/AppHeader';

export default function RootLayout() {
  const { pathname } = useLocation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        bgcolor: '#f7f8fa',
      }}
    >
      <AppHeader />

      <Box
        component="main"
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
        }}
      >
        <ErrorBoundary FallbackComponent={ErrorFallback} resetKeys={[pathname]}>
          <Outlet />
        </ErrorBoundary>
      </Box>
    </Box>
  );
}
